import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Button, Tooltip } from "@dhis2/ui";
import { Configuration } from "../../assets/data/config";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useActivityLogger } from "../../hooks/useActivityLogger";
import { Menu, MenuItem, makeStyles, Typography } from "@material-ui/core";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";

const useStyles = makeStyles((theme) => ({
  dropdownList: {
    maxHeight: "250px",
    overflowY: "auto",
    padding: 0,
  },
  menuItem: {
    borderBottom: "1px solid #ddd",
    padding: theme.spacing(1.5),
    whiteSpace: "normal",
  },
}));

const ApprovalNotification = () => {
  const classes = useStyles();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const baseURL =
    process.env.NODE_ENV === "development"
      ? "http://localhost:9000/mrunner_api"
      : `${window.location.protocol}//${window.location.host}/mrunner_api`;

  const { sessionUserBoValue } = useActivityLogger();

  const approveType = useMemo(() => {
    let type = null;
    if (
      Configuration.l1Approver.includes(
        sessionUserBoValue?.userCredentials?.userRoles[0].id
      )
    ) {
      type = "L1";
    }
    if (
      Configuration.l2Approver.includes(
        sessionUserBoValue?.userCredentials?.userRoles[0].id
      )
    ) {
      type = "L2";
    }
    return type;
  }, [sessionUserBoValue?.userCredentials?.userRoles]); //Don't remove ?

  const handleOpen = (event) => {
    getNotifications();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNotifications = async () => {
    try {
      setGlobalSpinner(true);
      const response = await axios.get(`${baseURL}/getApprovalRequests`);
      setNotifications(response.data);
    } catch (error) {
      console.log("Error in fetching notifications...");
    } finally {
      setDataLoaded(true);
      setGlobalSpinner(false);
    }
  };
  useEffect(() => {
    // getNotifications();
  }, []);

  const filteredNotifications = useMemo(() => {
    let arr = [];
    if (approveType === "L1") {
      arr = notifications.filter((n) => n.mne_status === "Pending");
    }
    if (approveType === "L2") {
      arr = notifications.filter((n) => n.final_status === "Pending");
    }
    return arr;
  }, [notifications, approveType]);

  return (
    <>
      {approveType ? (
        <>
          <Tooltip content="Notifications">
            {/* <Button small type="button" value="default"> */}
            <FontAwesomeIcon
              icon={faBell}
              className="ml-10px"
              onClick={handleOpen}
              style={{ cursor: "pointer" }}
            />
            {/* </Button> */}
          </Tooltip>

          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: { width: 400 },
            }}
          >
            <div className={classes.dropdownList}>
              {filteredNotifications.length > 0 ? (
                filteredNotifications.map((item, index) => (
                  <MenuItem
                    key={`${item.id}-${index}`} // better key to avoid index-only
                    onClick={handleClose}
                    className={classes.menuItem}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      style={{ width: "100%" }}
                    >
                      <div>
                        {item.submitted_by} submitted the {item.report_name} for
                        approval.
                      </div>
                      <div className="mt-10px fs-08125rem">
                        #{item.id} &nbsp;&nbsp; State:{" "}
                        <strong>{item.state}</strong> &nbsp;&nbsp; Facility:{" "}
                        <strong>{item.facility}</strong> &nbsp;&nbsp; Period:{" "}
                        <strong>{item.period}</strong>
                      </div>
                      <div className="text-right mt-10px fs-08125rem">
                        Submitted At:{" "}
                        <strong>
                          {moment(item.submitted_at).format("YYYY-MM-DD")}
                        </strong>
                      </div>
                    </Typography>
                  </MenuItem>
                ))
              ) : (
                <div className="text-center py-4 text-gray-500">
                  No data to display
                </div>
              )}
            </div>
          </Menu>
        </>
      ) : null}
    </>
  );
};

export default ApprovalNotification;
